const commentLookup = {
  botRef6: [
    `{"blocks":[{"key":"2c991","text":"We could make our standups async?","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`
  ]
} 

export default commentLookup
